import { useEffect } from "react";
import { toast } from "sonner";
import { connectAdminCommsWs } from "../../lib/ws";

/** Hook global do painel admin: abre WS /api/ws/admin/comms, toca chime e
 *  mostra toast quando WhatsApp/SMS inbound chega. Também insere o evento
 *  na tabela de histórico via `onInboundEvent` (opcional).
 *  Também aceita `onShowHistory` para o botão secundário do toast. */
export function useInboundToast({ onInboundEvent, onShowHistory } = {}) {
  useEffect(() => {
    const playChime = () => {
      try {
        const Ctx = window.AudioContext || window.webkitAudioContext;
        if (!Ctx) return;
        const ctx = new Ctx();
        const osc = ctx.createOscillator();
        const g = ctx.createGain();
        osc.type = "sine";
        osc.frequency.setValueAtTime(880, ctx.currentTime);
        osc.frequency.setValueAtTime(1174, ctx.currentTime + 0.12);
        g.gain.setValueAtTime(0.001, ctx.currentTime);
        g.gain.exponentialRampToValueAtTime(0.15, ctx.currentTime + 0.02);
        g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.4);
        osc.connect(g); g.connect(ctx.destination);
        osc.start(); osc.stop(ctx.currentTime + 0.42);
      } catch { /* som é enhancement */ }
    };
    const conn = connectAdminCommsWs({
      onEvent: (ev) => {
        if (ev.type !== "inbound") return;
        playChime();
        const rawFrom = ev.from || "";
        const from = rawFrom.replace("whatsapp:", "");
        const label = ev.channel === "whatsapp" ? "WhatsApp" : ev.channel === "sms" ? "SMS" : ev.channel;
        const digits = from.replace(/[^0-9]/g, "");
        const respondUrl = ev.channel === "whatsapp"
          ? `https://wa.me/${digits}?text=${encodeURIComponent("Olá, aqui é da RAF Direct. Recebemos seu contato — como podemos ajudar?")}`
          : `sms:+${digits}`;
        toast.info(`📥 ${label} recebido de ${from}`, {
          description: ev.preview || "(sem texto)",
          duration: 20000,
          action: {
            label: ev.channel === "whatsapp" ? "Responder wa.me" : "Responder SMS",
            onClick: () => window.open(respondUrl, "_blank"),
          },
          cancel: onShowHistory ? {
            label: "Ver histórico",
            onClick: () => onShowHistory(),
          } : undefined,
        });
        onInboundEvent && onInboundEvent(ev);
      },
    });
    return () => conn && conn.close();
  }, [onInboundEvent, onShowHistory]);
}

export default useInboundToast;
